"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearFixMixin = void 0;
// https://css-tricks.com/clearfix-a-lesson-in-web-development-evolution/
var clearFixMixin = function clearFixMixin() {
  return "\n    &:before,\n    &:after {\n        content: ' ';\n        display: table;\n    }\n    &:after {\n        clear: both;\n    }\n";
};
exports.clearFixMixin = clearFixMixin;